// NOTE: view for no-config and email-only  views
import * as React from "react"
import PropTypes from "prop-types"

// fields
import AssigneeWorkflowFields from "components/WorkflowModalForm/fields/AssigneeWorkflowFields/AssigneeWorkflowFields"
import InformTeamWorkflowFields from "components/WorkflowModalForm/fields/InformTeamWorkflowFields/InformTeamWorkflowFields"

const SendEmailWorkflow = ({ form, sendEmail, informTeam, setInformTeam }) => {
  return (
    <>
      {/* assignees */}
      <AssigneeWorkflowFields isEmail={sendEmail} />

      {/* notify members */}
      <InformTeamWorkflowFields
        form={form}
        informTeam={informTeam}
        setInformTeam={setInformTeam}
      />
    </>
  )
}

SendEmailWorkflow.propTypes = {}

export default SendEmailWorkflow
